module.exports = __webpack_public_path__ + "assets/listcoltree.b5466976.svg";